import agentEmploymentDetailsDictionary from '@entities/agent-employment-details/i18n/ru/agent-employment-details.dic.json';

export const agentEmploymentDetails = {
  AGENT_EMPLOYMENT_DETAILS: agentEmploymentDetailsDictionary,
};

export const agentEmploymentDetailsNamespaces = ['AGENT_EMPLOYMENT_DETAILS'];
